module.exports = "/images/vendor/flag-icon-css/flags/1x1/zw.svg?8b8854659c43952e254a914dfca52018";